import { persistTrace } from "@storage/trace-storage";
import { BaseTracer } from "@app-services/base-tracer.service";

class Tracer extends BaseTracer {

    protected override storeTrace(trace: string): void {
        persistTrace(trace);
    }
}

export const tracer: BaseTracer = new Tracer();